import { render, staticRenderFns } from "./MsSwitch.vue?vue&type=template&id=37c0817e&scoped=true"
import script from "./MsSwitch.vue?vue&type=script&lang=js"
export * from "./MsSwitch.vue?vue&type=script&lang=js"
import style0 from "./MsSwitch.vue?vue&type=style&index=0&id=37c0817e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c0817e",
  null
  
)

export default component.exports